import React from 'react';
import { Helmet } from 'react-helmet';
import { Phone, Mail, MapPin, Clock, Navigation, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';

const ContactsPage = () => {
  return (
    <div className="contacts-page min-h-screen">
      <Helmet>
        <title>Контакти - CIMM Computers | Ремонт техніки в Одесі</title>
        <meta name="description" content="Зв'яжіться з нами: +38 097 417 8788. Адреса майстерні CIMM в Одесі. Години роботи: Пн-Сб 11:00-18:00. Безкоштовна діагностика." />
        <meta name="keywords" content="контакти cimm, адреса майстерні одеса, ремонт телефонів контакти, ремонт ноутбуків одеса" />
        <meta property="og:title" content="Контакти - CIMM Computers" />
        <meta property="og:description" content="Зв'яжіться з майстернею CIMM в Одесі. Професійний ремонт техніки." />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Header */}
      <header className="cyber-header fixed top-0 left-0 right-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="text-2xl font-bold neon-text">CIMM</div>
            <div className="text-sm text-gray-400 hidden md:block">Комп'ютери та Ремонт</div>
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-gray-300 hover:text-orange-400/80 transition-all duration-300">Головна</Link>
            <Link to="/phones" className="text-gray-300 hover:text-orange-400/80 transition-all duration-300">Телефони</Link>
            <Link to="/laptops" className="text-gray-300 hover:text-orange-400/80 transition-all duration-300">Ноутбуки</Link>
            <Link to="/laptop-cleaning" className="text-gray-300 hover:text-orange-400/80 transition-all duration-300">Чистка</Link>
            <Link to="/contacts" className="text-orange-500">Контакти</Link>
          </nav>
          <a href="tel:+380974178788" className="neon-text font-semibold hover:drop-shadow-[0_0_15px_rgba(255,140,0,0.8)] transition-all duration-300">
            +38 097 417 8788
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-12 px-4 dark-section">
        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
              Наші <span className="neon-text">контакти</span>
            </h1>
            <p className="text-xl text-gray-400">Завітайте до нас або зв'яжіться зручним способом</p>
          </div>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="py-12 px-4 dark-section">
        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {/* Phone */}
            <div className="glass-card p-6 text-center group transition-all duration-300 hover:border-orange-500/50">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500/20 to-orange-600/20 rounded-xl flex items-center justify-center mx-auto mb-4 transition-all duration-300">
                <Phone className="w-8 h-8 text-orange-500 icon-glow" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Телефон</h3>
              <a href="tel:+380974178788" className="text-orange-500 hover:text-orange-400/80 transition-colors">
                +38 097 417 8788
              </a>
              <p className="text-gray-400 text-sm mt-2">Передзвоніть для запису</p>
            </div>

            {/* Address */}
            <div className="glass-card p-6 text-center group transition-all duration-300 hover:border-orange-500/50">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500/20 to-orange-600/20 rounded-xl flex items-center justify-center mx-auto mb-4 transition-all duration-300">
                <MapPin className="w-8 h-8 text-orange-500 icon-glow" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Адреса</h3>
              <p className="text-gray-300">м. Одеса</p>
              <p className="text-gray-400 text-sm mt-2">вул. Одеська, 45</p>
            </div>

            {/* Hours */}
            <div className="glass-card p-6 text-center group transition-all duration-300 hover:border-orange-500/50">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500/20 to-orange-600/20 rounded-xl flex items-center justify-center mx-auto mb-4 transition-all duration-300">
                <Clock className="w-8 h-8 text-orange-500 icon-glow" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Години роботи</h3>
              <p className="text-gray-300">Пн-Сб: 11:00 - 18:00</p>
              <p className="text-gray-400 text-sm mt-2">Неділя - вихідний</p>
            </div>

            {/* Instagram */}
            <div className="glass-card p-6 text-center group transition-all duration-300 hover:border-orange-500/50">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500/20 to-orange-600/20 rounded-xl flex items-center justify-center mx-auto mb-4 transition-all duration-300">
                <Instagram className="w-8 h-8 text-orange-500 icon-glow" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Instagram</h3>
              <a href="https://www.instagram.com/cimmodua/" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400/80 transition-colors">
                @cimmodua
              </a>
              <p className="text-gray-400 text-sm mt-2">Наші роботи</p>
            </div>
          </div>
        </div>
      </section>

      {/* Map and Directions */}
      <section className="py-12 px-4 dark-section">
        <div className="container mx-auto max-w-6xl relative z-10">
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Map */}
            <div className="glass-card p-6">
              <h2 className="text-2xl font-bold text-white mb-4">
                <MapPin className="inline w-6 h-6 text-orange-500 mr-2" />
                Наше розташування
              </h2>
              <div className="aspect-video bg-gray-900 rounded-lg overflow-hidden">
                {/* Google Maps Embed - замените координаты на реальные */}
                <iframe
                  src="https://maps.google.com/maps?q=%D0%9E%D0%B4%D0%B5%D1%81%D1%8C%D0%BA%D0%B0%2045%2C%20%D0%9E%D0%B4%D0%B5%D1%81%D0%B0&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="CIMM Location"
                ></iframe>
              </div>
              <p className="text-gray-400 text-sm mt-4">
                <Navigation className="inline w-4 h-4 text-orange-500 mr-1" />
                Наша адреса: м. Одеса, вул. Одеська, 45
              </p>
              <div className="mt-4 rounded-lg overflow-hidden border border-orange-500/20" data-testid="facade-photo">
                <img
                  src="https://customer-assets.emergentagent.com/job_06b6c2bb-4bc6-4771-9fb9-88aa1fa83a11/artifacts/wkvyqgxe_photo_2026-06-05_11-44-15.jpg"
                  alt="Фасад майстерні CIMM Computers, вул. Одеська, 45"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
                <p className="text-gray-400 text-xs p-3 text-center">
                  Шукайте нашу помаранчеву вивіску «CIMM Computers» — вхід на нижній рівень
                </p>
              </div>
            </div>

            {/* Directions and Info */}
            <div className="space-y-6">
              <div className="glass-card p-6">
                <h2 className="text-2xl font-bold text-white mb-4">Як нас знайти</h2>
                <div className="space-y-4 text-gray-300">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-orange-500/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-orange-500 font-bold">1</span>
                    </div>
                    <div>
                      <p className="font-semibold text-white">Передзвоніть нам</p>
                      <p className="text-sm text-gray-400">Зателефонуйте за номером +38 097 417 8788 для запису та отримання точної адреси</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-orange-500/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-orange-500 font-bold">2</span>
                    </div>
                    <div>
                      <p className="font-semibold text-white">Запишіться на зручний час</p>
                      <p className="text-sm text-gray-400">Ми працюємо Пн-Сб з 11:00 до 18:00. Оберіть зручний час для візиту</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-orange-500/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-orange-500 font-bold">3</span>
                    </div>
                    <div>
                      <p className="font-semibold text-white">Завітайте до майстерні</p>
                      <p className="text-sm text-gray-400">Принесіть ваш пристрій. Безкоштовна діагностика займе 15-30 хвилин</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="glass-card p-6 bg-gradient-to-br from-orange-500/10 to-transparent border border-orange-500/30">
                <h3 className="text-xl font-bold text-white mb-3">
                  💡 Важлива інформація
                </h3>
                <ul className="space-y-2 text-gray-300 text-sm">
                  <li>✓ Безкоштовна діагностика для всіх пристроїв</li>
                  <li>✓ Можливий експрес-ремонт за 1-2 години</li>
                  <li>✓ Гарантія на всі види робіт</li>
                  <li>✓ Оригінальні запчастини в наявності</li>
                  <li>✓ Прозоре ціноутворення без прихованих платежів</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-12 px-4 grid-bg">
        <div className="container mx-auto max-w-6xl relative z-10">
          <h2 className="text-3xl font-bold text-white mb-8 text-center">
            Наша <span className="neon-text">майстерня</span>
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {/* Placeholder images - замените на реальные фото */}
            <div className="gallery-item group aspect-video bg-gray-900 rounded-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_gadget-fix-center/artifacts/50glehzf_IMG_0941.jpeg"
                alt="CIMM Workshop 1"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="gallery-item group aspect-video bg-gray-900 rounded-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_gadget-fix-center/artifacts/50glehzf_IMG_0941.jpeg"
                alt="CIMM Workshop 2"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="gallery-item group aspect-video bg-gray-900 rounded-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_gadget-fix-center/artifacts/50glehzf_IMG_0941.jpeg"
                alt="CIMM Workshop 3"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
          </div>
          <p className="text-center text-gray-400 mt-6 text-sm">
            * Фото майстерні. Більше фото в нашому <a href="https://www.instagram.com/cimmodua/" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400/80 transition-colors">Instagram</a>
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 px-4 dark-section">
        <div className="container mx-auto max-w-4xl relative z-10 text-center">
          <div className="cta-card p-8">
            <h2 className="text-3xl font-bold text-white mb-4">
              Готові відремонтувати вашу техніку?
            </h2>
            <p className="text-gray-400 mb-6">
              Зателефонуйте нам зараз або запишіться онлайн
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a href="tel:+380974178788" className="inline-block">
                <button className="futuristic-btn bg-orange-500/90 hover:bg-orange-500 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300">
                  <Phone className="inline w-5 h-5 mr-2" />
                  Зателефонувати
                </button>
              </a>
              <Link to="/#booking">
                <button className="neon-border border-orange-500 text-orange-500 hover:bg-orange-500/10 hover:border-orange-400 bg-transparent px-8 py-3 rounded-lg font-semibold transition-all duration-300">
                  Записатися онлайн
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="cyber-footer py-12 px-4">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="text-2xl font-bold neon-text mb-4">CIMM Computers</h3>
              <p className="text-gray-400 mb-4">Професійний ремонт ноутбуків та телефонів в Одесі</p>
            </div>
            <div>
              <h4 className="font-semibold text-white mb-4">Послуги</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/laptops" className="hover:text-orange-400/80 transition-colors">Ремонт ноутбуків</Link></li>
                <li><Link to="/phones" className="hover:text-orange-400/80 transition-colors">Ремонт телефонів</Link></li>
                <li><Link to="/laptop-cleaning" className="hover:text-orange-400/80 transition-colors">Чистка ноутбуків</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-white mb-4">Контакти</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="tel:+380974178788" className="hover:text-orange-400/80 transition-colors">+38 097 417 8788</a></li>
                <li>м. Одеса, вул. Одеська, 45</li>
                <li>Пн-Сб: 11:00 - 18:00</li>
                <li><a href="https://www.instagram.com/cimmodua/" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400/80 transition-colors">@cimmodua</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-orange-500/20 pt-8 text-center text-gray-400">
            <p>© 2026 CIMM Computers. Всі права захищені.</p>
            <p className="text-xs text-gray-500 mt-3 max-w-3xl mx-auto">Незалежний сервісний центр з постгарантійного обслуговування. Ми не є офіційним (авторизованим) сервісним центром і не пов'язані з виробниками техніки (Apple, Samsung, Sony, Xiaomi та ін.). Усі назви брендів належать їхнім власникам.</p>
            <p className="mt-2">
              <Link to="/privacy-policy" className="hover:text-orange-500 transition-colors" data-testid="footer-privacy-link">Політика конфіденційності</Link>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactsPage;
